import { createAction, props } from '@ngrx/store';
import { ProductType } from '../../models/dbmodels';
import { ProductTypeSearchRequest, ProductTypeSearchResponse } from 'src/app/models/viewmodels';

export const loadAllProductTypes = createAction(
  '[Products] Load All Products Types'
);
export const loadProductTypesBySearchRequest = createAction(
  '[Products] Load All Products Types By Search Request',
  props<{ productTypeSearchRequest: ProductTypeSearchRequest }>()
);


export const loadProductTypesSuccess = createAction(
  '[Products] Load Product Types Success',
  props<{
    productTypes: ProductType[],
  }>()
);

export const loadProductTypesFailure = createAction(
  '[Products] Load Product Types Failure',
  props<{ error: Error }>()
);
